/* tslint:disable */
import { RespondAnswer } from "./RespondAnswer"

export class Respond {
		Id: number;
		Guid: string;
		CreateDate: Date;
		CompletionDate: Date;
		RespondentEmail: string;
		SessionId: string;
		FormId: number;

		RespondAnswers: RespondAnswer[];
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Respond.ts